module.exports = __webpack_public_path__ + "static/media/31.53dd16b0.jpeg";